import React from 'react'
import Skeleton from 'react-loading-skeleton'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const NeubauProjekteImageVideo = () => {
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000
    };

    return (
        <div className='slider_wrapper imgvideo_slider'>
            <Slider {...settings}>
                <div className='slider_slide_item'>
                    <img src='images/siedlungen-image-2.png' className='w-100' alt='#' />
                </div>
                <div className='slider_slide_item'>
                    <img src='images/siedlungen-image-2.png' className='w-100' alt='#' />
                </div>
                <div className='slider_slide_item'>
                    <img src='images/siedlungen-image-2.png' className='w-100' alt='#' />
                </div>
            </Slider>
        </div>
    )
}

export default NeubauProjekteImageVideo